module.exports = __webpack_public_path__ + "img/us_active@3x.8d90db76.png";